import DeleteConfirmation from "components/ui/DeleteConfirmation";
import {
  useDeleteSuperAdminHsn,
  useDeleteSuperAdminHsnGroup,
} from "http-hooks/superAdmin/useSuperAdminHsn";

export default function DeleteHsn({ id, type, onClose }) {
  const isGroup = type === "group";
  const { mutateAsync: deleteHsn, isPending: isDeletingHsn } = useDeleteSuperAdminHsn();
  const { mutateAsync: deleteGroup, isPending: isDeletingGroup } = useDeleteSuperAdminHsnGroup();
  const isDeleting = isDeletingHsn || isDeletingGroup;
  const entity = isGroup ? "HSN group" : "HSN record";

  const handleDelete = async () => {
    try {
      if (isGroup) await deleteGroup(id);
      else await deleteHsn(id);
      onClose();
    } catch (error) {
      console.error("HSN delete failed:", error);
    }
  };

  return (
    <DeleteConfirmation
      title={`Delete ${entity}`}
      description={`Are you sure you want to delete this ${entity}? This action cannot be undone.`}
      onDelete={handleDelete}
      onClose={onClose}
      isLoading={isDeleting}
    />
  );
}
